import { cn } from "../utils";

export const AppLogo: React.FC = () => {
	return (
		<div
			className={cn([
				"flex",
				"h-10",
				"w-10",
				"items-center",
				"justify-center",
				"bg-brand",
				"pr-px",
				"mb-px",
			])}
		>
			<svg
				className="h-7 w-7"
				width="48"
				height="48"
				viewBox="0 0 48 48"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.2718 36.728C4.24264 29.6986 4.24273 18.3018 11.2721 11.2725C18.3015 4.24303 31.0711 2.78719 40.9706 7.02983L36.7264 11.274C43.7555 18.3035 43.7554 29.7002 36.7261 36.7296C29.6967 43.759 16.9289 45.2131 7.02937 40.9705L11.2718 36.728ZM31.0708 16.929C27.1655 13.0241 20.8341 13.0242 16.9289 16.9293C13.0237 20.8346 13.0237 27.1662 16.9289 31.0715L16.9274 31.073C20.8327 34.978 27.1641 34.9779 31.0692 31.0727C34.9745 27.1675 34.9745 20.8358 31.0692 16.9306L31.0708 16.929Z"
					fill="white"
				/>
			</svg>
		</div>
	);
};
